import React, { createContext, useState, useEffect, useRef } from 'react'
import { supabase } from '../services/supabaseClient'
import LoadingOverlay from '../components/common/LoadingOverlay'
import { fetchUserRole } from '../api/supabaseApi'

export const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [session, setSession] = useState(null)
  const [role, setRole] = useState(null)
  const [loading, setLoading] = useState(true)
  const initialFetchDone = useRef(false)

  useEffect(() => {
    const handleAuthChange = async () => {
      try {
        const {
          data: { session },
        } = await supabase.auth.getSession()
        setSession(session)

        if (session) {
          const roleFetched = await fetchUserRole(session.user.id)
          setRole(roleFetched)
        } else {
          setRole(null)
        }
      } catch (error) {
        console.error('Error fetching session or role:', error)
      } finally {
        setLoading(false)
        initialFetchDone.current = true
      }
    }

    const { data: authListener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        setSession(session)
        setLoading(true)
        handleAuthChange()
      }
    )

    return () => {
      authListener.subscription.unsubscribe()
    }
  }, [])

  if (loading && !role) return <LoadingOverlay />

  return (
    <AuthContext.Provider
      value={{
        session,
        setSession,
        loading,
        role,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
